export const COLLECTION_VIEWED = 'collection:viewed'
